import { getCategories } from '../../services/api/categories';
import { GET_CATEGORY_LIST_REQUEST, GET_CATEGORY_LIST_SUCCESS, GET_CATEGORY_LIST_FAILURE } from '../types';
import { transformedCategories } from '../../transforms/category';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformedCategories([]),
	},
	getters: {
		categoryOptions: (state) => {
			const allOption = {
				name: 'All categories',
				value: null,
			};

			const categories = state.data.map((item) => {
				return {
					name: item.name,
					value: item.id,
				};
			});

			return [allOption, ...categories];
		},
	},

	mutations: {
		[GET_CATEGORY_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_CATEGORY_LIST_SUCCESS](state, { data }) {
			state.isLoading = false;
			state.data = transformedCategories(data);
		},
		[GET_CATEGORY_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getCategories({ commit }) {
			try {
				commit(GET_CATEGORY_LIST_REQUEST);
				const { data } = await getCategories();
				commit(GET_CATEGORY_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_CATEGORY_LIST_FAILURE, error);
			}
		},
	},
};
